/* eslint-disable arrow-body-style */
import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const getFeedsKeyword: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> = (payload, cancelTokenFunc = () => {}) => {
  let params: any = {
    url: `${prefix}/feeds/keyword`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    params.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(params) as Promise<any>;
};

export const getFeedsStats: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/feeds/stats`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getFeedsComments: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
  refreshTime?: number,
) => Promise<any> | any = (
  payload,
  cancelTokenFunc = () => {},
  refreshTime = 0,
) => {
  const params: any = {
    url: `${prefix}/feeds/comments`,
    method: 'post',
    data: payload,
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  };
  if (typeof cancelTokenFunc === 'function') {
    params.cancelToken = new axios.CancelToken(cancelTokenFunc);
  }

  return http(params) as Promise<overviewOriginType>;
};

// feeds/comments V2 标准 pattern（兼容 wrapperCancelRequest）
export const getFeedsCommentsV2 = (config: {
  data: any;
  cancelToken?: any;
  headers?: any;
}) => {
  return http({
    url: `${prefix}/feeds/comments`,
    method: 'post',
    ...config,
  });
};


// export const downloadFeedsComments: (
//   payload: any, 
// ) => Promise<any> | any = (
//   payload,  
// ) => {
//   const params: any = {
//     url: `${prefix}/feeds/download`,
//     method: 'post',
//     data: payload,
//     responseType: 'arraybuffer',
//     responseEncoding: 'utf8',
//     rawData: true,
//   };

//   return http(params);
// };

/**
 * COS 异步下载第一步：通知后端准备数据并返回 job_id
 * POST /feeds/download, 返回 JSON 含 { data: { job_id, status } }
 */
export const prepareFeedsCosDownload: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/feeds/download`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * COS 异步下载第二步：轮询获取下载链接
 * POST /feeds/download/status, 请求体 { job_id }, 返回 JSON 含 { data: { status, url } }
 */
export const pollFeedsCosDownloadStatus: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/feeds/download/status`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};



export const getFeedsCommentsToGPTReport: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/feeds/comments/auto_gpt_report`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getFeedsSearchComments: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = () => {},
) => {
  const params: any = {
    url: `${prefix}/feeds/search`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    params.cancelToken = new axios.CancelToken(cancelTokenFunc);
  }

  return http(params) as Promise<overviewOriginType>;
};

export const getFeedsReplyComments: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/feeds/reply_comments`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const updateFeedsCommentsInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/feeds/comments_edit`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getFeedsCommentsEditLog: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/feeds/comments_edit_log`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const updateNewsCommentsInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/news/comments_edit`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getNewsCommentsEditLog: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/news/comments_edit_log`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOpinionFeedsCommentsInfoDownload: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/feeds/commentsInfo_download`,
    method: 'post',
    data: payload,
    responseType: 'blob',
    responseEncoding: 'utf8',
  }) as Promise<overviewOriginType>;
};

export const getOpinionFeedsSearchDownload: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/feeds/search/commentsInfo_download`,
    method: 'post',
    data: payload,
    responseType: 'blob',
    responseEncoding: 'utf8',
  }) as Promise<overviewOriginType>;
};

export const getOpinionFeedsReviewers: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/feeds/reviewers`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getOpinionLiveVenue: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/feeds/live_venue`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};
export const deleteNewsItem: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/news/delete`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getUserPrompt: (payload: any) => Promise<any> = payload => {
  return http({
    url: `${prefix}/feeds/get_user_prompt`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const setUserPrompt: (payload: any) => Promise<any> = payload => {
  return http({
    url: `${prefix}/feeds/set_user_prompt`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getFeedsCommentsLatestEditLog: (
  payload: any,
) => Promise<any> = payload => {
  return http({
    url: `${prefix}/feeds/comments_latest_edit_log`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getFeedsMaxMetric: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
  refreshTime?: number,
) => Promise<any> | any = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/feeds/max_metric`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<any>;
};
